import React, { createContext, useState } from "react";
import { Toast } from "../components/common/Toast";
import SellerService from "../services/SellerService";

export const SellerContext = createContext("SellerContext");

const SellerContextProvider = ({ children }) => {
	const [sellerList, setSellerList] = useState([]);
	const [totalElements, setTotalElements] = useState(0);
	const [loadingSellerList, setLoadingSellerList] = useState(false);
	const [sellerListErrorMsg, setSellerListErrorMsg] = useState("");

	const getSellerList = async (params) => {
		setLoadingSellerList(true);
		try {
			setSellerListErrorMsg("");
			const response = await SellerService.getSellersList(params);
			setSellerList(response.data.content);
			setTotalElements(response.data.totalElements);
		} catch (error) {
			const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			setSellerListErrorMsg(message);
			Toast("error", "Error", message);
		} finally {
			setLoadingSellerList(false);
		}
	};

	return (
		<SellerContext.Provider
			value={{
				getSellerList,
				sellerList,
				loadingSellerList,
				sellerListErrorMsg,
				totalElements,
			}}
		>
			{children}
		</SellerContext.Provider>
	);
};

export default SellerContextProvider;
